import { render, staticRenderFns } from "./CollectionRecord.vue?vue&type=template&id=d13a8924&scoped=true&"
import script from "./CollectionRecord.vue?vue&type=script&lang=js&"
export * from "./CollectionRecord.vue?vue&type=script&lang=js&"
import style0 from "./CollectionRecord.vue?vue&type=style&index=0&id=d13a8924&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13a8924",
  null
  
)

export default component.exports